import { useState } from 'react';
import { Box } from '@mui/material';
import DynamicTabsComponent from '../../../components/DynamicTabs/DynamicTabsComponent';
import WorkReports from '../../../pages/WorkReports/ViewWorkReport';
import CourseReportsComponent from '../../../pages/CourseReports/CourseReportsComponent';

const WorkReportsTabs = [
  {
    title: 'Work Reports',
    index: 0,
    component: <WorkReports />,
  },
  {
    title: 'Course Reports',
    index: 1,
    component: <CourseReportsComponent />,
  },
];

const AdminWorkReportsComponent = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box className="main-content-overlay">
      <div className="main-content-div">
        <DynamicTabsComponent
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          TabsList={WorkReportsTabs}
        />
      </div>
    </Box>
  );
};

export default AdminWorkReportsComponent;
